module.exports = __webpack_public_path__ + "pc-static/img/5.a1581c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/5.jpg
// module id = 8FcD
// module chunks = 1